import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal from 'components/common/modal-component';
import { ModalButton } from 'models/utils/common/modal-button-model';
import shortid from 'shortid';

const UNLINKED_STATEMENT_CONFIRMATION_MODAL =
  'unlink-statement-confirmation-modal';
const UNLINKED_STATEMENT_CONFIRMATION_MODAL_ID =
  'unlink-statement-confirmation-modal-id';

const UnlinkStatementConfirmationModal = ({
  setShowUnlinkStatementConfirmationModal,
  onConfirm,
  statementName,
}) => {
  return (
    <Modal
      id={`${UNLINKED_STATEMENT_CONFIRMATION_MODAL_ID}_block`}
      primaryModalButton={
        new ModalButton({
          text: 'common.confirm',
          onClick: onConfirm,
        })
      }
      secondaryModalButton={
        new ModalButton({
          text: 'common.cancel',
          onClick: () => setShowUnlinkStatementConfirmationModal(false),
        })
      }
      onClose={() => setShowUnlinkStatementConfirmationModal(false)}
    >
      <div className={`${UNLINKED_STATEMENT_CONFIRMATION_MODAL}__msg`}>
        <FormattedMessage
          id="side-by-side-view.compare.left-panel.auto-tieout.unlink.statement.modal.message"
          values={{
            b: (...chunks) => (
              <strong
                key={`${UNLINKED_STATEMENT_CONFIRMATION_MODAL}-${shortid.generate()}`}
              >
                {chunks}
              </strong>
            ),
            statementName,
          }}
        />
      </div>
    </Modal>
  );
};

export default UnlinkStatementConfirmationModal;

UnlinkStatementConfirmationModal.propTypes = {
  /** func to confirm the unlinking of the statement */
  onConfirm: PropTypes.func.isRequired,
  /** function to show/hide the unlink statement confirmation modal */
  setShowUnlinkStatementConfirmationModal: PropTypes.func.isRequired,
  /** statement name to be unlinked */
  statementName: PropTypes.string.isRequired,
};
